<template>
	<div class="pt-6 px-6 flex-grow flex flex-col justify-start">
		<h1 class="text-2xl font-semibold text-gray-900 mb-4">
			{{ __("File uploads") }}
		</h1>

		<p class="mb-4">
			{{
				__(
					"These files will be published in your profile and will be available to your trading partners for smooth processing. Download here purchase conditions, directions etc."
				)
			}}
		</p>

		<div class="mb-4">
			<div
				class="flex border-b items-center py-3"
				v-for="upload in uploads"
				:key="upload.id"
			>
				<ui-icon class="h-5 w-5" name="file" stroke-width="2" />
				&nbsp;<a
					class="font-semibold"
					v-bind:href="showImage(upload.id)"
					target="_blank"
					>{{ upload.filename }}</a
				>
				&nbsp;<span v-if="upload.label_id">({{ __(upload.label_id) }})</span>
				<ui-button class="ml-auto" v-on:click="destroy(upload.id)"
					>{{ __("Delete") }}
				</ui-button>
			</div>
		</div>

		<div
			:key="'UPLOAD_FILE_' + hack"
			class="justify-start flex-grow flex flex-col gap-y-6"
		>
			<h2 class="text-2xl font-semibold text-gray-900">
				{{ __("Upload new file:") }}
			</h2>
			<form @submit.prevent="submit" class="space-y-6">
				<input type="file" @input="form.file = $event.target.files[0]" />
				<ui-validation-message :form="form" field="file" />
				<ui-select-group
					v-model="labelOption"
					class="col-span-8 md:col-span-4"
					field="type"
					type="select"
					label="Description"
					:options="labelOptions"
					:form="form"
					:required="true"
				></ui-select-group>

				<span v-if="templateDownloadUrl">
					Vorlage
					<a class="underline" target="_blank" :href="templateDownloadUrl"
						>hier</a
					>
					herunterladen
				</span>

				<ui-input-group
					v-if="labelOption == null"
					class="col-span-2"
					v-model="form.label_id"
					field="label_id"
					label="Please insert description"
					:form="form"
					:required="true"
					:key="'FORM' + form.label_id"
				></ui-input-group>

				<progress
					v-if="form.progress"
					:value="form.progress.percentage"
					max="100"
				>
					{{ form.progress.percentage }}%
				</progress>
			</form>
			<div
				class="mt-auto flex justify-end pt-4 pb-6 px-6 bg-gray-50 items-center -mx-6"
			>
				<ui-button v-on:click="submit()">{{ __("Upload") }}</ui-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		uploads: {
			type: Array,
			required: false,
			default: null,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		templateDownloadUrl() {
			const templateMap = {
				"Self declaration": "documents/Selbsterklaerung_CC.pdf",
				"Quality assurance agreement":
					"documents/qualitaetssicherungsvereinbarung.pdf",
			};
			if (templateMap[this.labelOption]) {
				return window.baseUrl + "/" + templateMap[this.labelOption];
			} else {
				return null;
			}
		},
	},
	data() {
		return {
			form: Vue.observable(
				this.$inertia.form({
					file: null,
					label_id: null,
					id: this.user.id,
					hack: 0,
					public: true,
				})
			),
			labelOptions: [
				{
					id: "Conditions of purchase",
					label: "Conditions of purchase",
				},
				{
					id: "Certificate",
					label: "Certificate",
				},
				{
					id: "Self declaration",
					label: "Self declaration",
				},
				{
					id: "Quality assurance agreement",
					label: "Quality assurance agreement",
				},
				{
					id: null,
					label: "Other ",
				},
			],
			labelOption: "Conditions of purchase",
			hack: 0,
		};
	},
	methods: {
		submit() {
			if (this.form.label_id == null && this.labelOption != null) {
				this.form.label_id = this.labelOption;
			}
			let that = this;
			this.form.post(
				this.$route("user.upload", { iframe_modal: this.iframeModal }),
				{
					preserveState: true,
					onSuccess() {
						that.form.reset();
						that.hack++;
					},
				}
			);
		},
		destroy(destroyId) {
			this.form.post(
				this.$route("user.destroy", {
					destroyId: destroyId,
					iframe_modal: this.iframeModal,
				}),
				{
					preserveState: true,
				}
			);
		},
		showImage(uploadId) {
			return this.$route("user_uploads.download", {
				id: uploadId,
			});
		},
	},
};
</script>
